import React from 'react'
import ReactDOM from 'react-dom'
import { MuiThemeProvider, createGenerateClassName, jssPreset } from '@material-ui/core/styles'
import { AppHeader } from '@ipd/js-common'
import { JssProvider } from 'react-jss'
import { create, SheetsRegistry } from 'jss'
import retargetEvents from 'react-shadow-dom-retarget-events'
import LearnMoreDialogComponent from '../components/profile-info/LearnMoreDialogComponent'

// this requires a class but transpiling hoses it; custom-elements-es5-adapter is supposed to fix but I can't get it to work
// class WebComponent extends HTMLElement { }
function WebComponent () {
  return Reflect.construct(HTMLElement, arguments, this.constructor || WebComponent)
}
WebComponent.prototype = Object.create(HTMLElement.prototype)
WebComponent.prototype.constructor = WebComponent
Object.setPrototypeOf(WebComponent, HTMLElement)

// this is really just to capture the MUI theme when setting up the render...maybe it'd be better to just make it a global?
export function initWebComponents (theme) {
  WebComponent.prototype.connectedCallback = function () {
    // shadow DOM setup, with a <style> node for JSS and a <span> for the React element
    const shadowRoot = this.attachShadow({ mode: 'open', delegatesFocus: true })
    const stylesAt = document.createElement('style')
    const mountAt = document.createElement('span')
    shadowRoot.appendChild(stylesAt)
    shadowRoot.appendChild(mountAt)

    // tell JSS to render at our <style> node inside the shadow DOM or it goes to the document <head>
    const sheetsRegistry = new SheetsRegistry()
    const sheetsManager = new Map()
    const jss = create({ ...jssPreset(), insertionPoint: stylesAt })
    ReactDOM.render(
        <JssProvider jss={jss} generateClassName={createGenerateClassName()} registry={sheetsRegistry}>
          <MuiThemeProvider theme={theme} sheetsManager={sheetsManager}>
              {this.render()}
          </MuiThemeProvider>
        </JssProvider>,
        mountAt
    )
    // React events don't work unless you render into the shadowRoot (which we can't do while keeping our <style> node)
    // retargetEvents sets up event handlers to delegate them back to React
    retargetEvents(shadowRoot)
  }

  // can't define until we've setup the connectedCallback
  customElements.define('ipd-header', IpdHeader)
  customElements.define('learn-more', LearnMore)
}

// Exposes a React component (divorced from container and store) as a web component
class IpdHeader extends WebComponent {
  render () {
    // testing data to pass to HeaderComponent so we don't need a store, etc.
    // can probably read this from data attribs or something
    const currentApp = 'CodeSource'
    const claims = [
        'Pharma', 'MedTech', 'TechMedia', 'Biologic', 'PayerStrategy', 'CodeSource', 'CodeSource_DataFiles', 'CodeSource_MaxDose',
        'CodeSource_NdcUnitPricing', 'CodeSource_Admin', 'Forecasting', 'UserProfile', 'UserProfile_ManageOwnUsers',
        'UserProfile_ManageOtherUsers', 'SiteAdmin', 'SiteAdmin_InternalOnlyReleasedFeatures', 'SiteAdmin_InternalUser', 'SiteAdmin_UserAccounts',
        'SiteAdmin_SendEmail', 'SiteAdmin_ComposeEmail'
    ]
    return <AppHeader currentApp={currentApp} claims={claims} />
  }
}

class LearnMore extends WebComponent {
  constructor () {
    super()
    this.onClose = () => {
      console.log('close clicked')
      this.dispatchEvent(new CustomEvent('close', { composed: true }))
    }
  }

  get origin () {
    return this.getAttribute('origin')
  }
  set origin (value) {
    this.setAttribute('origin', value)
  }
  get majorCategory () {
    return this.getAttribute('majorCategory')
  }
  set majorCategory (value) {
    this.setAttribute('majorCategory', value)
  }
  get minorCategory () {
    return this.getAttribute('minorCategory')
  }
  set minorCategory (value) {
    this.setAttribute('minorCategory', value)
  }
  get subClass () {
    return this.getAttribute('subClass')
  }
  set subClass (value) {
    this.setAttribute('subClass', value)
  }
  get productName () {
    return this.getAttribute('productName')
  }
  set productName (value) {
    this.setAttribute('productName', value)
  }
  get contact () {
    return this._contact || {}
  }
  set contact (value) {
    this._contact = value
  }
  get open () {
    return this.hasAttribute('open')
  }
  set open (value) {
    if (value) {
      this.setAttribute('open', '')
    } else {
      this.removeAttribute('open')
    }
  }

  render () {
    return <LearnMoreDialogComponent
      origin={this.origin}
      dialogOpen={this.open}
      handleCloseDialog={this.onClose}
      majorCategory={this.majorCategory}
      minorCategory={this.minorCategory}
      subClass={this.subClass}
      productName={this.productName}
      contact={this.contact} />
  }
}
